module.exports = __webpack_public_path__ + "img/Thailand-3.075e92dc.jpg";